module.exports = __webpack_public_path__ + "images/category_lp/watch/troubled-person_32dc6fb37efa71385dfebf92913fe69b.png";